/**
 * FmSpecimenManifest — the shared chrome both archetype galleries use to show a
 * contract probe's verdict.
 *
 * A gallery teaches hierarchy by demonstrating it, and this inverted its own:
 * the form-flow shell rendered its refusals manifest BOLD at ~17px, larger and
 * heavier than the section title above it, while the operational shell rendered
 * the same kind of line at regular body size. Two sibling shells, two treatments
 * for one piece of metadata — and at 390 the form-flow one became a ten-line wall
 * of near-black text between the reader and the specimen.
 *
 * So it is a disclosure, collapsed, in the smallest muted caption: this is test
 * metadata, not review content. It lives in ONE component precisely so the two
 * galleries cannot diverge again. The verdict text stays in the DOM either way,
 * which is what the boundary tests read.
 */
import React from 'react';
import { FmAccordion } from './FmAccordion';
import './FmSpecimenManifest.css';

export interface FmSpecimenManifestProps {
  /** What the probe proves, as the disclosure's own label. */
  summary: string;
  /** The probe's verdict. */
  verdict: string;
  'data-testid': string;
}

export const FmSpecimenManifest: React.FC<FmSpecimenManifestProps> = ({
  summary,
  verdict,
  'data-testid': testId,
}) => (
  <FmAccordion
    plain
    className="fm-specimen-manifest"
    items={[
      {
        key: 'verdict',
        label: summary,
        children: (
          <output className="fm-specimen-manifest__verdict" data-testid={testId}>
            {verdict}
          </output>
        ),
      },
    ]}
  />
);

FmSpecimenManifest.displayName = 'FmSpecimenManifest';

export default FmSpecimenManifest;
